import layoutHeaderAside from '@/layout/header-aside'

const meta = { auth: true }

export default {
  path: '/basic',
  title: '基本信息',
  component: layoutHeaderAside,
  children: (pre => [
    // {
    //   path: 'index',
    //   name: `${pre}index`,
    //   meta: { ...meta, cache: true, title: '财务首页' },
    //   component: () => import('@/views/finance/index')
    // },

    {
      path: 'customerManage/customer',
      name: `${pre}customer`,
      meta: { ...meta, cache: true, title: '客户管理' },
      component: () => import('@/views/basic/customerManage/customer')
    },
    {
      path: 'partnerManage/partner',
      name: `${pre}partner`,
      meta: { ...meta, cache: true, title: '供应商管理' },
      component: () => import('@/views/basic/partnerManage/partner')
    },
    {
      path: 'unitManage',
      name: `${pre}unitManage`,
      meta: { ...meta, cache: true, title: '单位管理' },
      component: () => import('@/views/basic/unitManage')
    },
    {
      path: 'expo',
      name: `${pre}expo`,
      meta: { ...meta, cache: true, title: '展会管理' },
      component: () => import('@/views/basic/expo')
    }
  ])('basic-')
}
